var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredMessanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5390_35961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9684 2.23381e-05C9.34753 0.0165306 -0.117904 9.31983 0.00111018 20.6032C0.061562 26.316 2.54103 31.4647 6.49212 35.1323C6.95874 35.5651 7.21377 36.1704 7.21377 36.7968V40.1893C7.21377 41.5053 8.61455 42.3803 9.84814 41.8355L13.6934 40.1352C14.2016 39.9105 14.775 39.8756 15.3124 40.0224C17.1156 40.5139 19.017 40.779 20.9807 40.7808C32.5459 40.7909 42 31.6197 42 20.3904C42.0009 9.11898 32.5809 -0.0164859 20.9684 2.23381e-05Z",
    fill: "url(#paint0_linear_5390_35961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5888 25.2379C26.5686 26.7989 24.4024 27.2098 22.8487 26.1361L21.0864 24.9188L17.9931 22.7823C17.4116 22.3805 16.6244 22.406 16.0711 22.8433L9.89001 27.738C8.87924 28.538 7.49084 27.3489 8.1888 26.2807L14.4103 16.763C15.4304 15.2021 17.5966 14.7911 19.1504 15.8639L21.7186 17.6376L24.0069 19.2177C24.5884 19.6195 25.3756 19.594 25.9289 19.1567L32.11 14.262C33.1208 13.462 34.5092 14.6511 33.8112 15.7193L27.5888 25.2379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_35961",
    x1: -0.000264112,
    y1: 0,
    x2: -0.000264112,
    y2: 42.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5390_35961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredMessanger);
export default __webpack_public_path__ + "static/media/ic-colored-messanger.63ab2d2f51767c0a8962629a8a18a0b0.svg";
export { ForwardRef as ReactComponent };